// extracted by mini-css-extract-plugin
export default {"heading":"ApprovalsTab_heading__gcdJO","card":"ApprovalsTab_card__BQbym","approveBtn":"ApprovalsTab_approveBtn__qnGDq","empty":"ApprovalsTab_empty__yGpVc"};